module.exports = __webpack_public_path__ + "img/user-renewal.bdb248e3.svg";